

// https://medium.com/@vannyvanngoggygogg/laravel-on-modals-2c41a98898e4

$(document).on('ajax:success', function(e, xhr){
    if(!$('#modal').length){
        $('body').append($('<div class="modal" id="modal"></div>'))
    }

    $('#modal').html(xhr).modal('show');
});